import { APIClient } from "../api";

export default class EmailTemplateService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getEmailTemplates(idBusinessUnit: number, idServiceGroup: number) {
        const url = `${this.endpoint}/EmailTemplate?$filter=(((IdBusinessUnit eq ${idBusinessUnit} and IdServiceGroup eq ${idServiceGroup}) or IdBusinessUnit eq ${idBusinessUnit} or VisibleOtherBusinessUnit eq 1) and Disabled eq 0)&$top=200`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getUserCommunicationTemplate(IdTemplate: number) {
        const url = `${this.endpoint}/EmailTemplate/UserCommunicationTemplate/${IdTemplate}`;

        return this.api({
            method: 'get',
            url
        });
    }
}